const ProveedorIcon = ({
    size,
    width = 42,
    height = 42,
    color = "#0468fb",
    ...rest
  }) => {
    const w = width  ?? size;
    const h = height ?? size;


    return (
        <svg viewBox="0 0 1080 1080" width={w} height={h} version="1.1" xmlns="http://www.w3.org/2000/svg" >

        <g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        fill={color} stroke="none">
        <path d="M2513 9570 c-58 -35 -60 -41 -114 -335 -45 -252 -42 -240 -64 -237
        -11 2 -121 39 -244 83 -129 45 -241 79 -263 79 -42 0 -93 -37 -118 -87 -8 -15
        -29 -50 -46 -78 -17 -27 -75 -127 -128 -221 -76 -136 -96 -178 -96 -210 0 -63
        -1 -61 317 -332 56 -48 101 -90 100 -94 -2 -7 -156 -141 -265 -232 -191 -157
        -192 -168 -54 -406 222 -383 220 -380 299 -380 31 0 296 87 476 156 30 11 39
        11 42 2 2 -7 25 -124 50 -261 25 -136 50 -255 56 -265 6 -9 23 -26 37 -37 26
        -19 43 -20 349 -20 l322 0 30 29 c38 36 33 22 77 251 60 315 59 310 75 307 7
        -2 115 -39 239 -82 132 -47 242 -80 264 -80 81 0 86 7 338 453 60 106 70 150
        47 199 -6 13 -100 99 -210 193 -109 93 -199 172 -199 175 0 3 32 32 72 65 250
        211 315 269 330 293 31 47 23 99 -28 187 -25 44 -84 148 -131 230 -112 197
        -122 212 -160 230 -57 28 -62 27 -413 -99 -85 -30 -158 -52 -162 -50 -4 3 -8
        13 -8 21 0 9 -6 44 -14 77 -8 34 -26 129 -41 211 -36 208 -40 219 -83 254
        l-37 31 -305 0 c-285 0 -307 -1 -337 -20z m491 -277 c3 -16 20 -104 36 -198
        17 -93 36 -195 41 -226 6 -31 19 -70 29 -87 24 -39 115 -92 158 -92 18 0 143
        39 278 87 134 47 246 84 247 82 8 -10 147 -258 147 -262 0 -2 -87 -79 -194
        -171 -107 -92 -202 -178 -210 -191 -11 -17 -16 -48 -16 -99 0 -88 4 -95 136
        -207 83 -70 259 -222 278 -239 10 -10 -134 -270 -150 -270 -5 0 -113 37 -240
        82 -266 95 -293 99 -369 51 -27 -18 -57 -44 -66 -60 -10 -15 -35 -129 -58
        -253 -23 -124 -44 -237 -47 -252 l-6 -28 -152 0 -153 0 -12 53 c-7 28 -29 144
        -50 258 -23 125 -45 216 -56 233 -20 30 -122 86 -157 86 -13 0 -131 -38 -262
        -85 -132 -47 -245 -85 -250 -85 -6 0 -20 17 -32 38 -11 20 -44 77 -72 125 -29
        49 -52 92 -52 96 0 4 84 80 188 168 103 88 196 170 207 183 23 25 34 147 16
        192 -5 15 -96 100 -211 198 -148 128 -199 177 -195 189 10 27 136 240 145 246
        4 3 116 -33 248 -80 133 -47 256 -85 274 -85 40 0 131 51 154 85 17 26 25 64
        69 310 14 77 31 161 37 188 l12 47 152 0 152 0 6 -27z"/>
        <path d="M2780 8644 c-122 -22 -211 -67 -295 -150 -100 -98 -144 -208 -145
        -360 0 -143 46 -253 149 -354 162 -159 387 -193 593 -89 115 58 222 193 257
        324 16 59 13 203 -5 264 -45 154 -167 282 -320 338 -61 21 -184 36 -234 27z
        m169 -294 c160 -82 176 -304 28 -406 -157 -109 -367 4 -367 198 0 172 187 287
        339 208z"/>
        <path d="M7063 9570 c-54 -32 -53 -30 -118 -385 -15 -77 -37 -201 -51 -275
        -13 -74 -26 -140 -28 -147 -4 -9 -28 -3 -88 19 -46 16 -210 75 -366 129 -260
        91 -286 99 -320 89 -20 -6 -46 -18 -58 -28 -12 -9 -61 -87 -110 -172 -48 -85
        -132 -231 -186 -325 -109 -189 -121 -219 -107 -270 11 -38 68 -92 381 -358
        102 -86 192 -165 201 -175 15 -16 9 -23 -91 -107 -58 -50 -145 -124 -192 -165
        -47 -41 -127 -110 -178 -153 -161 -136 -162 -141 -28 -378 283 -502 289 -512
        337 -537 28 -15 55 -22 74 -19 26 5 300 99 618 214 63 23 102 32 108 26 8 -8
        42 -181 100 -508 38 -218 48 -252 80 -280 17 -14 40 -27 52 -30 12 -3 203 -4
        424 -3 l403 3 31 32 c35 35 32 19 115 473 44 243 62 320 73 320 3 0 121 -41
        261 -91 140 -50 301 -106 358 -125 166 -56 184 -46 309 173 49 87 135 238 191
        335 92 159 102 182 102 227 0 60 -11 74 -140 186 -51 44 -132 114 -180 155
        -48 41 -128 110 -178 153 -51 43 -92 82 -92 86 0 4 89 83 198 176 298 256 366
        316 379 339 7 12 12 42 13 67 0 50 20 12 -287 549 -95 166 -103 176 -149 200
        l-48 24 -206 -71 c-113 -39 -270 -95 -350 -123 -197 -71 -187 -70 -199 -24 -9
        34 -62 316 -119 629 -14 80 -20 93 -54 127 l-38 38 -407 0 c-387 0 -410 -1
        -440 -20z m707 -372 c107 -582 116 -628 139 -652 33 -35 134 -86 169 -86 17 0
        95 23 174 51 78 28 193 68 253 89 61 21 148 52 195 69 47 17 92 31 100 31 9 0
        41 -48 78 -113 34 -61 89 -157 122 -212 l59 -100 -33 -30 c-18 -16 -88 -77
        -156 -135 -68 -58 -160 -137 -204 -175 -45 -39 -102 -88 -128 -108 -25 -21
        -53 -53 -62 -71 -18 -39 -21 -138 -5 -184 8 -22 84 -94 272 -254 144 -123 274
        -234 289 -248 l28 -25 -126 -217 -125 -217 -182 64 c-100 34 -259 90 -353 124
        -94 34 -182 61 -195 61 -31 0 -113 -40 -158 -78 -34 -28 -34 -29 -77 -263 -24
        -128 -55 -298 -70 -376 l-26 -143 -253 0 -252 0 -6 33 c-62 365 -131 706 -146
        727 -23 33 -119 89 -162 96 -26 4 -95 -16 -294 -86 -143 -51 -296 -105 -340
        -120 -44 -16 -87 -31 -96 -35 -13 -5 -33 23 -92 127 -42 73 -99 171 -126 218
        -48 80 -50 86 -33 101 9 9 139 120 288 247 199 169 275 240 283 263 14 41 14
        137 0 176 -7 22 -80 91 -242 229 -127 110 -255 218 -284 242 -29 24 -53 49
        -53 57 0 7 46 91 101 187 56 95 109 188 118 206 19 41 25 40 186 -18 486 -174
        540 -192 581 -187 46 5 145 63 168 99 12 18 146 706 146 748 0 7 86 10 254 10
        l254 0 22 -122z"/>
        <path d="M7320 8277 c-154 -46 -278 -137 -361 -264 -263 -403 -19 -927 462
        -994 238 -32 494 92 621 303 76 124 103 232 95 378 -12 239 -168 458 -392 553
        -124 53 -296 62 -425 24z m334 -281 c74 -36 112 -69 153 -133 91 -142 78 -325
        -33 -451 -112 -128 -303 -162 -456 -80 -73 39 -122 92 -161 177 -28 58 -31 76
        -31 151 1 70 5 95 28 144 35 79 66 118 124 158 76 53 134 69 233 65 69 -2 97
        -8 143 -31z"/>
        <path d="M3510 6650 c-292 -29 -550 -147 -814 -374 -102 -88 -199 -234 -246
        -372 -84 -240 -58 -567 72 -904 26 -67 50 -150 57 -199 26 -176 113 -383 234
        -559 l51 -74 -42 -187 c-62 -274 -57 -259 -100 -270 -20 -5 -181 -44 -357 -86
        -451 -108 -501 -122 -562 -153 -109 -56 -214 -166 -247 -261 -15 -42 -41 -313
        -81 -856 -9 -115 -20 -251 -25 -302 -6 -51 -10 -142 -10 -203 l0 -110 2021 0
        c1998 0 2021 0 2049 20 15 11 35 36 45 56 19 40 19 39 -5 334 -6 69 -21 269
        -35 445 -45 579 -44 574 -75 641 -42 93 -135 186 -235 234 -82 40 -94 43 -715
        191 -118 28 -222 55 -231 60 -9 5 -22 40 -33 91 -10 46 -33 146 -52 223 -18
        76 -30 142 -25 145 23 15 131 189 182 295 54 111 109 284 109 343 0 13 38 110
        84 215 46 106 95 228 109 273 91 287 73 503 -53 663 -49 62 -80 121 -109 212
        -109 333 -483 516 -961 469z m332 -280 c117 -24 206 -65 276 -126 54 -47 76
        -87 136 -244 23 -62 55 -121 91 -168 70 -95 79 -124 72 -236 -5 -91 -44 -247
        -62 -253 -6 -2 -21 25 -34 59 -104 273 -251 438 -431 484 -124 32 -222 2 -360
        -109 -153 -124 -207 -138 -335 -88 -103 39 -154 47 -210 31 -98 -27 -157 -112
        -211 -305 -15 -55 -33 -113 -39 -129 -15 -35 -15 -35 -45 113 -25 130 -26 237
        0 345 40 173 105 272 256 387 107 82 215 147 306 184 177 72 402 93 590 55z
        m-5 -751 c40 -15 119 -95 158 -160 80 -136 177 -454 177 -579 0 -107 -71 -293
        -168 -440 -80 -123 -176 -210 -298 -271 -90 -45 -115 -53 -178 -57 -57 -3 -87
        1 -138 18 -139 46 -283 156 -364 279 -87 131 -165 313 -181 424 -7 43 -4 53
        34 116 64 109 115 237 162 413 12 43 26 78 33 78 6 0 39 -9 71 -21 175 -61
        354 -18 532 128 102 84 114 90 160 72z m-457 -1765 c152 -30 306 -4 457 76
        l73 39 9 -37 c33 -124 61 -243 61 -255 0 -8 -39 -46 -87 -84 -127 -100 -312
        -245 -355 -277 l-37 -28 -93 74 c-163 130 -282 222 -330 258 -29 21 -48 43
        -48 55 0 18 53 249 64 281 3 7 41 -6 103 -37 65 -32 127 -54 183 -65z m-482
        -437 c32 -24 162 -125 289 -225 248 -193 276 -212 320 -212 40 0 69 20 362
        250 144 113 271 211 284 218 19 12 74 1 462 -92 471 -114 498 -123 557 -198
        l30 -36 24 -289 c13 -158 24 -300 24 -315 l0 -28 -210 0 -210 0 0 35 c0 88
        -56 145 -144 145 -44 0 -53 -4 -86 -39 -20 -21 -40 -53 -44 -71 -3 -18 -6
        -149 -6 -291 l0 -259 -1050 0 -1050 0 0 275 c0 300 -4 323 -55 363 -20 16 -41
        22 -80 22 -83 0 -135 -56 -135 -145 l0 -35 -210 0 -210 0 0 28 c0 38 39 540
        46 580 6 40 64 106 116 133 21 11 149 46 285 79 137 33 329 80 428 104 99 24
        186 45 193 45 8 1 39 -18 70 -42z m-718 -1302 l0 -105 -231 0 -231 0 7 98 c4
        53 9 100 12 105 2 4 103 7 224 7 l219 0 0 -105z m3094 73 c3 -18 8 -66 11
        -105 l6 -73 -230 0 -231 0 0 105 0 105 220 0 219 0 5 -32z"/>
        <path d="M3443 2760 c-53 -32 -63 -64 -63 -200 0 -87 4 -129 15 -150 49 -95
        191 -96 240 0 21 40 21 247 1 295 -29 68 -126 96 -193 55z"/>
        <path d="M5243 6611 c-49 -23 -73 -56 -79 -108 -5 -41 -9 -34 356 -663 62
        -107 133 -229 157 -270 l43 -75 0 -1260 c0 -1232 1 -1261 20 -1292 41 -68
        -102 -63 1805 -63 1581 0 1729 1 1755 16 79 47 81 177 3 230 -25 17 -51 19
        -215 22 l-188 4 0 345 c0 329 -1 347 -20 378 -11 18 -28 37 -38 42 -9 4 -156
        10 -327 13 l-310 5 -3 263 -2 262 112 0 c96 0 118 3 146 20 61 37 62 45 62
        512 0 402 -1 425 -20 455 -10 18 -31 40 -47 50 -26 17 -73 18 -833 18 -880 0
        -839 3 -884 -58 -20 -27 -21 -43 -26 -380 l-5 -352 -120 -5 c-208 -9 -199 11
        -205 -435 l-5 -350 -55 -5 c-67 -7 -95 -21 -120 -63 -19 -30 -20 -53 -20 -374
        l0 -343 -95 0 -95 0 -2 1213 -3 1212 -71 120 c-74 126 -243 418 -401 695 -104
        181 -123 206 -170 226 -41 18 -49 17 -100 -5z m3005 -1623 l2 -258 -635 0
        -635 0 0 253 c0 140 3 257 7 260 3 4 288 6 632 5 l626 -3 3 -257z m-320 -791
        l2 -257 -637 2 -638 3 -2 245 c-2 135 -1 251 2 258 3 10 136 12 637 10 l633
        -3 3 -258z m702 -787 l0 -260 -1090 0 -1090 0 0 253 c0 140 3 257 7 260 3 4
        494 7 1090 7 l1083 0 0 -260z"/>
        <path d="M6571 2704 c-204 -55 -361 -259 -361 -469 1 -268 225 -495 489 -495
        213 0 402 137 470 338 42 124 24 292 -43 407 -33 55 -142 157 -200 184 -105
        51 -244 65 -355 35z m222 -270 c58 -29 107 -85 123 -141 64 -220 -213 -378
        -373 -213 -106 109 -64 302 77 359 40 16 137 13 173 -5z"/>
        <path d="M8227 2696 c-160 -57 -266 -168 -317 -335 -92 -295 154 -621 468
        -621 142 0 277 61 374 169 242 269 108 703 -245 797 -83 22 -200 18 -280 -10z
        m269 -276 c59 -33 89 -75 105 -146 36 -157 -119 -297 -281 -254 -62 16 -132
        89 -149 154 -48 194 153 345 325 246z"/>
        </g>
        </svg>
    
    );
};



export default ProveedorIcon;